import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";

declare var alertify:any;
@Component({
  templateUrl:"./share.html"
})

export class Share implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService
  ){}

  private data:any=[];

  ngOnInit(): void {
    this.getData();
  }



  private getData(){
    this.http.getData(API.parameter).then(res=>{
      this.data=res.data;
    });
  }
  private editShare(id:number){
    this.router.navigate(['index/share',id]);
  }

}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/share/share.component.ts